import useS3ParamsAlertNotificationListener from 'src/components/Toasts/AlertNotifications/hooks/useS3ParamsAlertNotificationListener';
import useEventEmitterAlertNotificationListener from 'src/components/Toasts/AlertNotifications/hooks/useEventEmitterAlertNotificationListener';
import usePreLaunchMarketAlertNotificationListener from 'src/components/Toasts/AlertNotifications/hooks/usePreLaunchMarketAlertNotificationListener';

export default function useAlertNotificationListener() {
	useS3ParamsAlertNotificationListener();
	useEventEmitterAlertNotificationListener();
	usePreLaunchMarketAlertNotificationListener();
}
